import { useState, useEffect, useCallback } from "react";

// Components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { useAsyncDebounce } from "react-table";

import { AdminHeader } from "shared/components/common/AdminHeader";
import { Loading } from "shared/components/ui/Loading";
import { Chip, InputAdornment, Tooltip } from "@mui/material";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Icon
import { Search } from "@mui/icons-material";
import { ReactComponent as Edit } from "components/icon/svg/edit.svg";
import { ReactComponent as Delete } from "components/icon/svg/delete.svg";

// Redux
import { useLazyGetLXOsQuery } from "shared/redux/endpoints/admin";

// Router
import { useNavigate } from "react-router-dom";

//Utils
// import moment from "moment";
// import { toast } from "react-toastify";

// Img
import AvaImg from "assets/images/ava.png";
import AdvanceTable from "components/AdvancedTable/AdvanceTable";

export default function LXOListPage() {
  const navigation = useNavigate();
  const [trigger, { isLoading }] = useLazyGetLXOsQuery();
  const initialState = {
    page: 0,
    size: 10,
    sort: "created,desc",
    search: "",
  };
  const [state, setState] = useState(initialState);
  const [pagination, setPagination] = useState({
    totalPage: 0,
    pageSize: 0,
    currentPage: 0,
    totalElement: 0,
  });
  const [dataTable, setDataTable] = useState({
    columns: [
      { Header: "LXO name", accessor: "fullName", width: 250 },
      { Header: "Email", accessor: "email", width: 250 },
      { Header: "User code", accessor: "userCode" },
      { Header: "Default center", accessor: "centerName" },
      { Header: "Status", accessor: "status", width: 100 },
      { Header: "Action", accessor: "action", width: 100 },
    ],
    rows: [],
  });

  const fetchTasks = useCallback(async (params) => {
    const resp = await trigger(params);

    if (resp?.data) {
      setDataTable({
        ...dataTable,
        rows: resp.data.map((item) => {
          return {
            ...item,
            fullName: (
              <MDBox
                className="avatar"
                onClick={() => handleModalAction(item, "view")}
                sx={{ cursor: "pointer" }}
              >
                <MDBox
                  className="avatar-img"
                  component="img"
                  src={item.avatar ?? AvaImg}
                ></MDBox>
                <span>{item.fullName}</span>
              </MDBox>
            ),
            centerName: (
              <Tooltip title={item.centerName}>
                <Chip className="chip-center" label={item.centerName} />
              </Tooltip>
            ),
            status: (
              <Chip
                className={`chip-status chip-status-${item.status}`}
                sx={{
                  cursor: "default",
                  background:
                    item.status === "INACTIVE" ? "#FDD1DA" : "#B0EED3",
                  color: item.status === "INACTIVE" ? "#F80031" : "#1AAE6F",
                }}
                label={item.status}
              />
            ),
            action: (
              <MDBox className="action-icon">
                <Edit
                  className="action-icon"
                  onClick={() => handleModalAction(item, "view")}
                />
                <Delete className="action-icon disabled" />
              </MDBox>
            ),
          };
        }),
      });
      setPagination({
        totalPage: resp.data.totalPage,
        pageSize: resp.data.pageSize,
        currentPage: resp.data.currentPage,
        totalElement: resp.data.totalElement,
      });
      setState((prev) => ({ ...prev, ...params }));
    }
  }, []);

  const handleModalAction = useCallback((item, action) => {
    switch (action) {
      case "view":
        navigation(`/user-management/lxo-detail/${item.userId}`);
        break;
      default:
        break;
    }
  }, []);

  const handleSearch = useAsyncDebounce((value) => {
    fetchTasks({ ...state, search: value?.trim() || "", page: 0 });
  }, 1000);

  const handlePageChange = useCallback(
    (page) => {
      fetchTasks({ ...state, page });
    },
    [state, fetchTasks]
  );

  const handleFilterChange = useCallback(
    (key, e) => {
      const value = e?.value || e; // Handle select (object) and text/datepicker (string)
      fetchTasks({ ...state, [key]: value, page: 0 });
    },
    [state, fetchTasks]
  );

  const advanceTableProps = {
    columns: dataTable.columns,
    rows: dataTable.rows,
    filters: [
      {
        key: "search",
        label: "Search here",
        value: state.search,
        type: "text",
        startAdornment: (
          <InputAdornment position="start">
            <Search className="icon-search" />
          </InputAdornment>
        ),
        onChange: (e) => handleSearch(e.target.value),
      },
    ],
    pagination,
    onPageChange: handlePageChange,
    onFilterChange: handleFilterChange,
    totalElements: pagination.totalElement,
  };

  useEffect(() => {
    fetchTasks(initialState);
  }, [fetchTasks]);

  return (
    <DashboardLayout>
      <AdminHeader />
      <DashboardNavbar light />
      {isLoading ? (
        <MDBox className="container-lxo-management">
          <MDBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            width="100%"
            height={300}
          >
            <Loading style={{ width: 150, height: 100 }} />
          </MDBox>
        </MDBox>
      ) : (
        <MDBox className="container-lxo-management">
          <MDBox className="header-lxo-task">
            <MDBox className="group-title">
              <MDTypography className="title">LXO Management</MDTypography>
            </MDBox>
          </MDBox>
          <MDBox className="content-lxo-task">
            <AdvanceTable {...advanceTableProps} />
          </MDBox>
        </MDBox>
      )}
    </DashboardLayout>
  );
}
